import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, OperatorFunction, Subject } from 'rxjs';
import { filter } from 'rxjs/operators';

import { Bucket } from './buckets-store';
import { AppStoreEventType } from './types';

export interface AppStoreEvent<T = any, AD = any> {
  type: AppStoreEventType;
  data?: T;
  error?: HttpErrorResponse;
  bucket?: Bucket<T> | any;
  additionalData?: AD;
  [key: string]: any;
}

function byType(evtType: string): OperatorFunction<AppStoreEvent, AppStoreEvent> {
  return (source: Observable<AppStoreEvent>) =>
    source.pipe(filter(event => event.type === evtType));
}

function byTypes(evtTypes: string[]): OperatorFunction<AppStoreEvent, AppStoreEvent> {
  return (source: Observable<AppStoreEvent>) =>
    source.pipe(filter(event => evtTypes.includes(event.type)));
}

export function filterEventTypes<T = any>(
  eventTypeOrTypes: string | string[],
): OperatorFunction<AppStoreEvent<any>, AppStoreEvent<T>> {
  return Array.isArray(eventTypeOrTypes)
    ? eventTypeOrTypes.length > 1
      ? byTypes(eventTypeOrTypes)
      : byType(eventTypeOrTypes[0])
    : byType(eventTypeOrTypes);
}

@Injectable({ providedIn: 'root' })
export class AppStore extends Subject<AppStoreEvent> {
  public dispatch(event: AppStoreEvent): void {
    this.next(event);
  }

  public filterEventType<T = any, AD = any>(
    eventTypes: AppStoreEventType[],
  ): Observable<AppStoreEvent<T, AD>> {
    return filterEventTypes(eventTypes).apply(null, [this]);
  }
}
